
export default superclass => class extends superclass  {
    onNewStep(step) {
        this.currentStep = step;

        let state = this.store && this.store.getState();
        if (state && state.automation.parameterSliderDown.indexOf(this) > -1) {
            if (state.mix.isRecordingMix) {
                this.mixAutomation.removeAtStep(this.currentStep);
            } else if (state.sequencer.isRecording) {
                this.automation.removeAtStep(this.currentStep);
            } 
        }
    }

    get automation() {
        if (this.isPatternLocked()) {
            let a = this.patternToAutomation[this.currentPattern];
            if (a === undefined) {
                this.patternToAutomation[this.currentPattern] = this.previousAutomation.getCopy(this.store);
                this.patternToAutomation[this.currentPattern].updateRedux();
            }
            this.previousAutomation = this.patternToAutomation[this.currentPattern];
            return this.previousAutomation;
        }
        this.previousAutomation = this.unlockedAutomation;
        return this.unlockedAutomation; // || {automations: []};
    }

    get automations() {
        return this.automation ? this.automation.automations : [];
    }

    get isRecording() {
        if (!this.store) {
            return false;
        }
        let state = this.store.getState();
        return state.sequencer.isRecording &&
            Object.values(state.sequencer.isPlaying).some(x => x) &&
            this.automatable;
    }

    get isRecordingMix() {
        if (!this.store) {
            return false;
        }
        let state = this.store.getState();
        return state.mix.isRecordingMix &&
            Object.values(state.sequencer.isPlaying).some(x => x) &&
            this.automatable;
    }

    get isPlayingMix() {
        if (!this.store) {
            return false;
        }
        let state = this.store.getState();
        return state.mix.isPlayingMix &&
            this.automatable;
    }

    getAtStep(step) {
        if (this.hasMacro) {
            let {macroParameter} = this.hasMacro;
            let value = macroParameter.getAtStep(step);
            return this.hasMacro.normalizeParameterValue(this, value);
        }

        if (this.isPlayingMix && this.mixAutomation.automations.length > 0) {
            if (!this.mixAutomation.hasEventsAfterStep(step) &&
                this.isPatternLocked()) {
                // revert to locked values if there are no events after step
                return this.get(true);
            } 
            let v = this.mixAutomation.getValueAtStep(step);
            if (this.isConnectedToAnyModulator()) {
                return v + this.get(true);
            }
            return v;
        } else if (this.automations && this.automations.length > 0) {
            let v = this.automation.getValueAtStep(step);
            if (this.isConnectedToAnyModulator()) {
                return v + this.get(true);
            }
            return v;
        }

        return this.get();
    }

    // returns whether we should look at automation to determine
    // the true value at this step
    shouldUseGetAtStep() {
        // either it has automations or a macro that has automations
        if (this.store && this.store.getState().automation.parameterSliderDown.indexOf(this) > -1) {
            return false;
        }

        let automations = this.automations;
        let macroAutomations = undefined;
        if (this.store) {
            let isPlayingMix = this.isPlayingMix;
            automations = isPlayingMix ? 
                [
                    ...this.mixAutomation.automations,
                    ...this.automations
                ] :
                
                this.automations;
            if (this.hasMacro) {
                macroAutomations = isPlayingMix ?
                    [... this.hasMacro.macroParameter.automations,
                     ... this.hasMacro.macroParameter.mixAutomation.automations] :
                    this.hasMacro.macroParameter.automations;
            }
        }
        return (automations.length > 0 ||
             (this.hasMacro && (macroAutomations.length > 0 ||
                                this.hasMacro.macroParameter.isConnectedToAnyModulator())));
    }

    deleteAutomations() {
        this.automation.deleteAutomations();
        this.patternToAutomation = {};
    }

    set automatedValue(val) {
        // check if locked
        if (this.isPaletteLocked()) {
            this.paletteToValue[this.getCurrentPalette()] = val;
        } else if (this.isPatternLocked()) {
            this.patternToValue[this.currentPattern] = val;
        } else {
            this.unlockedValue = val;
        }
    }

    set automationRate(rate) {
        rate = this.config.automationRate || rate;
        if (this.audioParam &&
            this.audioParam.input) {
            if (!this.constantAutomationRate) {
                this.audioParam.input.automationRate = rate;
            } 
        }
        if (this.audioParams) {
            for (let audioParam of this.audioParams) {
                if (audioParam &&
                    audioParam.input ) {
                    if (!this.constantAutomationRate) {
                        audioParam.input.automationRate = rate;
                    } 
                }
            }
        }
    }

    get automationRate() {
        if (this.audioParams) {
            return this.audioParams[0] && this.audioParams[0].input &&
                this.audioParams[0].input.automationRate;
        }
        return this.audioParam &&
            this.audioParam.input &&
            this.audioParam.input.automationRate;
    }

    hasAnyAutomation() {
        for (let i in this.patternToAutomation) {
            if (this.patternToAutomation[i].automations.length > 0) {
                return true;
            }
        }
        return this.automations && this.automations.length > 0;
    }
}
